module.exports = "./img/desktop_logo.f03ea27.png";